import { BaseEdge, EdgeProps, getSmoothStepPath } from "@xyflow/react";
import { Button } from "@quake/shared-ui/components/ui/button";
import PlusIcon from "lucide-react/dist/esm/icons/plus";
import { CSSProperties } from "react";

type ButtonEdgeProps = EdgeProps & {
  data?: {
    onEdgeClick: (nodeId: string) => void;
  };
  style?: CSSProperties;
};

export default function ButtonEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  data,
  markerEnd,
}: ButtonEdgeProps) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <BaseEdge path={edgePath} style={style} markerEnd={markerEnd} markerWidth={0} markerHeight={0} />
      <foreignObject
        width={24}
        height={24}
        x={(sourceX + targetX) / 2 - 12}
        y={targetY - 5}
        className="edgebutton-foreignobject"
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <div className="h-full w-full flex items-center justify-center z-50 ">
          <Button
            size="sm"
            variant="outline"
            className="rounded-full h-6 w-6 p-0 bg-white shadow-sm"
            onClick={(event) => {
              event.stopPropagation();
              if (data?.onEdgeClick && typeof id === "string") {
                const sourceNodeId = id.split("-")[1] ?? "";
                data.onEdgeClick(sourceNodeId);
              }
            }}
          >
            <PlusIcon className="h-3 w-3" />
          </Button>
        </div>
      </foreignObject>
    </>
  );
}
